import { appApiHeaders, getApiUrl } from '@/utils/api-utils'
import { apiCall } from '@ngtrvu/use-api'

const FETCH_POST = 'FETCH_POST'
const FETCH_POSTS = 'FETCH_POSTS'
const FETCH_PAGES = 'FETCH_PAGES'

export const getPostApi = apiCall(
  FETCH_POST,
  ({ siteId, postId }: { siteId: string; postId: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/posts/${postId}`),
    method: 'GET',
    headers: appApiHeaders(),
  }),
)

export const getPostsApi = apiCall(
  FETCH_POSTS,
  ({ siteId }: { siteId: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/posts`),
    method: 'GET',
    headers: appApiHeaders(),
  }),
)

export const getPagesApi = apiCall(
  FETCH_PAGES,
  ({ siteId }: { siteId: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/pages`),
    method: 'GET',
    headers: appApiHeaders(),
  }),
)
